import { useApiQuery } from "../infrastructure/hooks/useApiQuery";
import { useAuthentication } from "../infrastructure/hooks/useAuthentication";
import { endpointsMetadata } from "../infrastructure/routes/endpointsMetadata";
import { IResolvedPreReservationForm } from "./models";

// These endpoints require an authenticated user (UserRole.User). The portal lets
// guests browse and pick a service/class before logging in, so we must not fetch
// until authenticated — otherwise the 403 handler in useApiQuery force-logs-out
// and bounces the user to the homepage. The user authenticates during the wizard,
// so the form is loaded by the time they reach the reserve step.

/** Fetches the pre-reservation form attached to a group event, if any. */
export const usePreReservationFormForEvent = (eventId?: number) => {
  const { isAuthenticated } = useAuthentication();
  const enabled = !!eventId && isAuthenticated;

  const { data } = useApiQuery<IResolvedPreReservationForm | null>({
    queryKey: [endpointsMetadata.preReservationForm.getForEvent, eventId],
    endpoint: `${endpointsMetadata.preReservationForm.getForEvent}?eventId=${
      eventId ?? 0
    }`,
    enabled,
    globalIsLoading: false,
  });

  return data ?? null;
};

/** Fetches the pre-reservation form attached to a service, if any. */
export const usePreReservationFormForService = (serviceId?: number) => {
  const { isAuthenticated } = useAuthentication();

  const { data } = useApiQuery<IResolvedPreReservationForm | null>({
    queryKey: [endpointsMetadata.preReservationForm.getForService, serviceId],
    endpoint: `${
      endpointsMetadata.preReservationForm.getForService
    }?serviceId=${serviceId ?? 0}`,
    enabled: !!serviceId && isAuthenticated,
    globalIsLoading: false,
  });

  return data ?? null;
};
